import axios from 'axios';

export interface ILeadData {
  leadData: {
    data: Record<string, unknown>;
    type: string;
    typeName?: string;
  };
  leadPlatforms: {
    google_sheet: {
      sheet_name: string;
    };
    lsq?: {
      add_lead: boolean;
      add_activity?: boolean;
    };
    salesforce?: boolean;
  };
}

class CleartaxLeadFormCall {
  sendClearLeadData(formData: ILeadData) {
    return axios.post('/f/common-lead/common-add-lead', formData);
  }
}

export default new CleartaxLeadFormCall();
